import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap/esm/index";

// Import Components
import ITPHeroHeader from "../../components/HeroHeader/ITPHeroHeader";
import Accordion from "../../components/shared-ui/Accordion/Accordion";
import ItpNavigation from "../../components/ITPNavigation/ITPNavigation";
import ISIITPinline from "../../components/shared-ui/ISI/ISIITP-inline";
import FooterITP from "../../components/shared-ui/Footer/Footer-ITP";
import BackToTopBtn from "../../components/shared-ui/BackToTopBtn/BackToTopBtn";
import ISIwrapper from "../../components/shared-ui/ISI/ISI-wrapper";
import ISIITP from "../../components/shared-ui/ISI/ISIITP";
import YoutubeEmbed from "../../components/shared-ui/Video/YoutubeEmbed";
import LookingForSupport from "../../components/shared-ui/Cards/LookingForSupport";

import "../../css/AboutDoptelet.scss";

//SEO
import Helmet from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import PrimaryButton from "../../components/shared-ui/Buttons/PrimaryButton";

function showTermsModal(event) {
  event.preventDefault();
  let modal = document.getElementById("terms-modal");
  document.body.classList.add("no-scroll");
  modal.classList.remove("fadeOut");
  modal.style.display = "block";
  modal.classList.add("fadeIn");
  modal.style.height = "100vh";
  if (
    event.length &&
    event.currentTarget.classList.contains("scroll-to-terms")
  ) {
    const terms = document.getElementById("terms");
    const container = document.querySelector("#terms-modal .modal-container");
    container.scroll(0, terms.offsetTop);
  }
}

function AboutDoptelet() {
  useEffect(() => {
    window.scrollTo(0, 0);
    let location = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      page: {
        path: `${location}`,
        title: "What is DOPTELET® (avatrombopag) for ITP & CLD in Adults",
        environment: "dev",
        indication: "ITP",
        audience: "DTC",
      },
    });
  }, []);
  return (
    <div className="main_content_wrap">
      <Helmet
        script={[
          helmetJsonLdProp({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Drug",
                name: "Doptelet",
                alternateName: "avatrombopag",
                manufacturer: {
                  "@type": "Organization",
                  name: "Sobi",
                },
                dosageForm: "Pill",
              },
              {
                "@type": "WebSite",
                about: {
                  "@type": "Thing",
                  description:
                    "To inform patients of Doptelet (avatrombopag), a prescription medicine used to treat low blood platelet counts in adults with chronic immune thrombocytopenia when other treatments have not worked well enough. Doptelet (avatrombopag) is also a prescription medicine used to treat low blood platelet counts in adults with long-lasting (chronic) liver disease who are scheduled to have a medical or dental procedure.",
                },
                url: "https://doptelethcp.com/itp/what-is-doptelet/",
              },
              {
                "@type": "Brand",
                logo: "https://doptelet.com/images/doptelet-avatrombopag-tablets-logo.svg",
              },
              {
                "@type": "Brand",
                logo: "https://doptelet.com/images/sobi-logo.png",
              },
              {
                url: "https://doptelet.com/what-is-doptelet/",
                "@type": "Substance",
                name: "Avatrombopag",
                description:
                  "Avatrombopag is the active substance found in Doptelet, a medication used for the treatment of chronic immune thrombocytopenia (ITP) in certain adult patients.",
              },
              {
                "@type": "MedicalStudy",
                url: "https://doptelet.com/what-is-doptelet/",
                name: "Clinical Trials for Doptelet",
                description:
                  "Explore the clinical trials conducted on Doptelet (avatrombopag) for the treatment of chronic immune thrombocytopenia (ITP) in adults.",
                studyLocation: [
                  {
                    "@type": "AdministrativeArea",
                    name: "United States",
                  },
                ],
                sponsor: {
                  "@type": "Organization",
                  name: "Dova Pharmaceuticals",
                },
              },
              {
                "@type": "MedicalIndication",
                url: "https://doptelet.com/what-is-doptelet/",
                name: "Chronic Immune Thrombocytopenia (ITP) Treatment",
                description:
                  "Doptelet is indicated for the treatment of chronic immune thrombocytopenia (ITP) in certain adult patients.",
                medicineSystem: "http://purl.bioontology.org/ontology/RXNORM",
              },
              {
                "@type": "MedicalGuideline",
                url: "https://doptelet.com/what-is-doptelet/",
                name: "Chronic Immune Thrombocytopenia (ITP) Treatment Guidelines",
                description:
                  "Explore the treatment guidelines for chronic immune thrombocytopenia (ITP) and learn about Doptelet as an approved medication for certain adult patients.",
                guidelineSubject: {
                  "@type": "MedicalEntity",
                  name: "Chronic immune thrombocytopenia (ITP)",
                },
                evidenceLevel: "Level B",
                evidenceOrigin: "Clinical trials and expert consensus",
                guidelineDate: "2022-01-01",
              },
              {
                "@type": "MedicalWebPage",
                url: "https://doptelet.com/what-is-doptelet/",
                name: "What is Doptelet?",
                description:
                  "Learn about Doptelet (avatrombopag), a medication approved for the treatment of chronic immune thrombocytopenia (ITP) in certain adult patients.",
              },
              {
                "@type": "MedicalTherapy",
                url: "https://doptelet.com/what-is-doptelet/",
                name: "Doptelet Usage",
                description:
                  "Learn about the usage of Doptelet (avatrombopag) for the treatment of chronic immune thrombocytopenia (ITP) in certain adult patients.",
                adverseOutcome:
                  "Common side effects may include nausea, fatigue, headache, and muscle or joint pain. Contact your healthcare provider if you experience severe or persistent adverse reactions.",
              },
              {
                "@type": "DrugClass",
                url: "https://doptelet.com/what-is-doptelet/",
                name: "Thrombopoietin Receptor Agonists",
                description:
                  "Thrombopoietin receptor agonists are a class of medications that stimulate the production and differentiation of megakaryocytes, leading to increased platelet production.",
                drug: {
                  "@type": "Drug",
                  name: "Doptelet",
                },
              },
            ],
          }),
        ]}>
        <title>
          About Doptelet: A Chronic ITP Treatment Medication | DOPTELET®
          (avatrombopag)
        </title>
        <meta
          name="description"
          content="Living with chronic ITP? Learn about different treatment options and medications like Doptelet, a thrombopoietin receptor agonist (TPO-RA) that can help."
        />
        <link rel="canonical" href="https://doptelet.com/what-is-doptelet/" />
      </Helmet>
      <ItpNavigation />
      <div className="inner-content-wrap about-doptelet">
        <ITPHeroHeader
          extraClass="large-hero inner-bg"
          markup={
            <>
              <h1>GET THE DOPTELET LIFT</h1>
              <p className="mb-0">
                Doptelet is a pill that helps your body make more platelets while you compromise less on your personal preferences. That means no doctor’s appointments for treatment injections, no restrictions on what you can eat and when, and more.
              </p>
            </>
          }
          maxWidth="515"
          bgImage={[
            "about-doptelet-hero.jpg",
            "about-doptelet-hero@2x.jpg",
          ]}
          bgImageMobile={[
            "about-doptelet-hero-mobile.jpg",
            "about-doptelet-hero-mobile@2x.jpg",
          ]}
          imageAlt="Doptelet platelet characters getting ice cream cones at a soft serve stand in carnival scenery"
        />

        <section className="section-padding clinical-trial">
          <Container>
            <Row>
              <Col>
                <h2>Reach new heights with a platelet count lift that lasts</h2>
                <p><strong>In the 6-month clinical trial, Doptelet was shown to:</strong></p>
                <div className="orange-border" style={{marginBottom: 40}}>
                  <div className="d-flex flex-column flex-md-row">
                    <div>
                      <p className="text-blue sign">LIFT PLATELETS</p>
                      <p>Raise platelet counts to <strong>50,000</strong> per microliter <strong>or more</strong>.</p>
                      <p className="mb-0">And for some, raise platelet counts to 100,000 per microliter or more. Read more about the results from the clinical trial and follow up review of data below.</p>
                    </div>
                    <div>
                      <p className="text-blue sign">ACT FAST</p>
                      <p className="mb-0">Lift platelet counts in as few as <strong>8 days</strong>.</p>
                    </div>
                    <div>
                      <p className="text-blue sign">AND LAST</p>
                      <p className="mb-0">Maintain an increase in platelet counts for an average of <strong>12 total weeks</strong>.</p>
                    </div>
                  </div>
                </div>

                <Accordion
                  title="More results from the clinical trial"
                  id="more-results"
                  className="scroll-to-section mb-0"
                  markup={
                    <>
                    <ul>
                      <li>49 people were in a 6-month clinical trial for Doptelet (clinical trials for a rare disease usually have smaller sample sizes than non-rare disease trials)</li>
                      <li>During that time, people taking Doptelet were compared with people not taking Doptelet</li>
                      <li>In the 6-month trial, those taking Doptelet were able to keep platelet counts at 50,000 platelets per microliter or higher for an average of 12 total weeks vs 0 weeks for those not taking Doptelet</li>
                      <li>On Day 8 of the trial, 21 out of 32 people taking Doptelet reached at least 50,000 platelets per microliter or more. Those who were not taking Doptelet did not reach 50,000 platelets per microliter</li>
                      <li>A follow-up review of the data from the clinical trial showed that 26 out of 32 patients reached at least 100,000 platelets per microliter at some point during the 6-month trial. The clinical trial was not designed to specifically measure if platelet counts reached 100,000 per microliter. Researchers identified this data in a follow-up review of the clinical trial results. Because this data was reviewed after the clinical trial, it is important to know these results might not be reliable in future clinical trials</li>
                    </ul>
                    </>
                  }
                />

              </Col>
            </Row>
          </Container>
        </section>

        <section className="cloud-blue-bg section-padding what-makes-doptelet-different">
          <Container>
            <Row className="align-items-center">
              <Col lg={{ span: 12 }}>
                <h2>What makes Doptelet different?</h2>
                <h3>Doptelet helps make treating chronic ITP more predictable by working with your body <br className="d-none d-md-block" /> to make more platelets with less compromises.</h3>
                <div className="navy-bg">
                  <Row className="ml-md-0 mr-md-0">
                    <Col md={12} lg={4} className="pl-md-0">
                      <div className="d-flex align-items-center mb-3">
                        <img
                          style={{maxWidth: 64}}
                          src="/images/clock.png"
                          alt="Clock icon representing a flexible schedule for taking Doptelet medication"
                          className="mr-3"
                        />
                        <h3 className="text-white mb-0"><strong>Fits your schedule</strong></h3>
                      </div>
                      <p className="mb-4 mb-lg-0">You can choose when to take Doptelet, as long as it’s at the same time each day.</p>
                    </Col>
                    <Col md={12} lg={4}>
                      <div className="d-flex align-items-center mb-3">
                        <img
                          style={{maxWidth: 64}}
                          src="/images/injection.png"
                          alt="Needle icon representing no treatment injections or infusions are needed with Doptelet"
                          className="mr-3"
                        />
                        <h3 className="text-white mb-0"><strong>No treatment injections or infusions</strong></h3>
                      </div>
                      <p className="mb-4 mb-lg-0">Doptelet isn’t a steroid or immunosuppressant—it’s a thrombopoietin receptor agonist (TPO-RA) pill that can be taken anywhere.</p>
                    </Col>
                    <Col md={12} lg={4} className="pr-md-0">
                      <div className="d-flex align-items-center mb-3">
                        <img
                          style={{maxWidth: 64}}
                          src="/images/icecream.png"
                          alt="Ice cream cone icon representing no food restrictions when taking Doptelet"
                          className="mr-3"
                        />
                        <h3 className="text-white mb-0"><strong>No food-type restrictions</strong></h3>
                      </div>
                      <p className="mb-4 mb-lg-0">Doptelet is a TPO-RA that allows you to eat any food you want, at anytime, without impacting the effectiveness of your treatment. With Doptelet, you can have dairy before bed and don’t need to be up at 5 AM to enjoy a bowl of cereal for breakfast. It‘s totally up to you!</p>
                    </Col>
                  </Row>
                  <Row className="ml-md-0 mr-md-0">
                    <Col md={12} lg={4} className="pl-md-0">
                      <div className="d-flex align-items-center mb-3">
                        <img
                          style={{maxWidth: 64}}
                          src="/images/no-liver-damage.png"
                          alt="Lab tests icon representing liver monitoring is not required while taking Doptelet"
                          className="mr-3"
                        />
                        <h3 className="text-white mb-0"><strong>No additional risk of liver damage</strong></h3>
                      </div>
                      <p className="mb-4 mb-lg-0">Doptelet doesn’t require additional liver-function monitoring because in clinical trials it was not shown to lead to liver damage (or “hepatotoxicity,” in medical terms).</p>
                    </Col>
                    <Col md={12} lg={4}>
                      <div className="d-flex align-items-center mb-3">
                        <img
                          style={{maxWidth: 64}}
                          src="/images/eye-exams.png"
                          alt="Eye with magnifying glass representing no eye exams are required before and during Doptelet treatment"
                          className="mr-3"
                        />
                        <h3 className="text-white mb-0"><strong>No eye exams</strong></h3>
                      </div>
                      <p className="mb-4 mb-lg-0">Doptelet can be used in people with cataracts. No eye exams are required before starting and during treatment with Doptelet.</p>
                    </Col>
                    <Col md={12} lg={4} className="pr-md-0">

                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="video-section">
          <Container>
            <Row>
              <Col lg={5} className="align-content-center">
                <h2>
                  How Doptelet Works
                </h2>
                <p className="pr-0 mb-0">
                  In this video, you will learn how Doptelet can lift platelet counts.
                </p>
                <div className="video-wrapper d-lg-none">
                  <YoutubeEmbed
                    embedId="PgE1VQj2szQ"
                    image={[
                      "how-doptelet-works.jpg",
                      "how-doptelet-works@2x.jpg"
                    ]}
                    imageMobile={[
                      "how-doptelet-works.jpg",
                      "how-doptelet-works@2x.jpg"
                    ]}
                    alt="Play Video: How Doptelet Works"
                  />
                </div>
              </Col>
              <Col lg={7} className="d-none d-lg-block">
                <div className="video-wrapper">
                  <YoutubeEmbed
                    embedId="PgE1VQj2szQ"
                    image={[
                      "how-doptelet-works.jpg",
                      "how-doptelet-works@2x.jpg"
                    ]}
                    imageMobile={[
                      "how-doptelet-works.jpg",
                      "how-doptelet-works@2x.jpg"
                    ]}
                    alt="Play Video: How Doptelet Works"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <section className="cloud-blue-bg section-padding">
          <Container>
            <Row className="flex-column-reverse flex-lg-row">
              <Col md={12} lg={8}>
                <h2 className="mb-4">With Doptelet, there's a chance you may experience side effects</h2>
                <h3>Serious side effects</h3>
                <p className="mb-2">Doptelet is a TPO-RA, and TPO-RAs have been associated with blood clots. Tell your doctor right away if you have symptoms of a blood clot, including:</p>
                <ul className="mb-4">
                  <li>Swelling, pain, or tenderness in your legs</li>
                  <li>Shortness of breath</li>
                  <li>Chest pain</li>
                  <li>Fast heartbeat</li>
                  <li>Stomach (abdominal) pain or tenderness</li>
                </ul>
                <h3>Common side effects</h3>
                <p className="mb-4">You should know that the most common side effects of Doptelet are headache, tiredness, bruising, nosebleed, upper respiratory tract infection, joint pain, gum bleeding, purple or red spots on your skin (petechiae), and runny nose.</p>
                <p className="mb-0 text-blue"><strong>These are not all the possible side effects of Doptelet. Talk to your doctor if any side effect bothers you or does not go away.</strong></p>
              </Col>
              <Col md={12} lg={4} className="text-md-center">
                <img
                  src="/images/platey_waving.png"
                  alt="Surprised doptelet platelet character with glasses"
                  className="d-block m-auto"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section-padding">
          <Container>
            <Row>
              <Col>
                <h2>How do I take Doptelet?</h2>
                <p>Doptelet is a 20-mg pill that must be taken with food. Your doctor will decide how much Doptelet you need to take, and for how<br className="d-none d-md-block" /> long, based on how your platelet count responds.</p>
                <p className="mb-0">Before starting Doptelet, you’ll want to tell your doctor about all of your medical conditions, like if you’ve ever had a blood clot,<br className="d-none d-md-block" /> are pregnant, or plan to be pregnant.</p>
              </Col>
            </Row>
          </Container>
        </section>

        <LookingForSupport addClass="section-padding pt-0" />

        <ISIITPinline />
      </div>
      <FooterITP />
      <ISIwrapper>
        <ISIITP />
      </ISIwrapper>
      <BackToTopBtn />
    </div>
  );
}

export default AboutDoptelet;
